import React, { useCallback, useState } from "react"
import { createContext, useContext } from "react"

type IContext = {
  isLoading: boolean
  setLoading: (loading: boolean, text: string) => void
  text: string
}

const LoadingContext = createContext<IContext>({
  isLoading: false,
  setLoading: () => {},
  text: "",
})

export const useLoadingData = () => useContext(LoadingContext)

type LoadingProviderProps = {
  children: React.ReactNode
}

export const LoadingProvider: React.FC<LoadingProviderProps> = ({
  children,
}) => {
  const [loading, setLoadingOpen] = useState(false)
  const [text, setText] = useState("")

  const handleLoading = useCallback((loading: boolean, text: string) => {
    setLoadingOpen(loading)
    setText(text)
  }, [])

  const context = React.useMemo(
    () => ({ isLoading: loading, setLoading: handleLoading, text }),
    [loading]
  )
  return (
    <LoadingContext.Provider value={context}>
      {children}
    </LoadingContext.Provider>
  )
}
